/**
 * Entry point com oidcEarlyInit - carrega app após verificação de auth
 */
import { oidcEarlyInit } from 'oidc-spa/entrypoint';
import './oidc'; // Side effect: createOidc

const { shouldLoadApp } = oidcEarlyInit({
  BASE_URL: import.meta.env.BASE_URL || '/',
});

if (shouldLoadApp) {
  import('./main.lazy').catch((err) => {
    console.error('[Spatuno] Falha ao carregar aplicação:', err);
    showLoadErrorUI(err);
  });
}

/**
 * Exibe UI de erro quando o import dinâmico falha (ex: chunk 404 em modo normal com cache desatualizado).
 * Permite ao usuário recarregar em vez de ficar preso no loading.
 */
function showLoadErrorUI(err: unknown) {
  const loadingEl = document.getElementById('app-loading');
  if (loadingEl) {
    // Detectar tema atual
    const isDark = document.documentElement.classList.contains('dark');
    
    // Cores baseadas no tema
    const bgColor = isDark ? 'hsl(220 21% 16%)' : '#F5F4F7';
    const textColor = isDark ? 'hsl(210 40% 98%)' : '#374151';
    const textSecondaryColor = isDark ? 'hsl(215 20% 65%)' : '#6b7280';
    
    loadingEl.innerHTML = `
      <div style="text-align:center;max-width:400px;padding:1.5rem">
        <p style="font-size:1rem;font-weight:600;color:${textColor};margin-bottom:0.5rem">Não foi possível carregar a aplicação</p>
        <p style="font-size:0.875rem;color:${textSecondaryColor};margin-bottom:1rem">Isso pode ocorrer após atualizações ou com cache desatualizado. Tente recarregar a página.</p>
        <button type="button" onclick="window.location.reload()" style="padding:0.5rem 1rem;font-size:0.875rem;font-weight:500;color:white;background:#975ec6;border:none;border-radius:0.375rem;cursor:pointer">
          Recarregar página
        </button>
      </div>
    `;
    loadingEl.style.background = bgColor;
  }
}
